module.exports = __webpack_public_path__ + "img/management_team.558f55f6.jpg";